import { render, staticRenderFns } from "./RequestReportDetail.vue?vue&type=template&id=48411bd4&scoped=true&"
import script from "./RequestReportDetail.vue?vue&type=script&lang=js&"
export * from "./RequestReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./RequestReportDetail.vue?vue&type=style&index=0&id=48411bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48411bd4",
  null
  
)

export default component.exports